import { FunctionComponent, useLayoutEffect, useState } from "react";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
  Outlet,
} from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../Redux/Store/Hooks";
import { permissionsToPage } from "../Redux/Slices/UserPermission/PermissionsToPage";
import {
  clearMenu,
  listSideMenuPermission,
} from "../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import Loading from "../Components/Loading/Loading";

interface PrivateRouteProps {
  element?: React.ReactNode;
}

const isAuthenticated = () => {
  return sessionStorage.getItem("token");
};

const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({ element }) => {
  const location = useLocation();
  const params = useParams();
  const dispatch = useAppDispatch();
  const nav = useNavigate();
  const { data: menu, isLoading } = useAppSelector(
    (state) => state.SideMenuPermission
  );
  
 
  const [menuFetchInitiated, setMenuFetchInitiated] = useState(false);


  const locationName = Object.values(params).reduce(
    (path, param) => path?.replace("/" + param, ""),
    location.pathname
  );

  console.log("📍 Current route:", locationName);


  useLayoutEffect(() => {
    // Skip if already initiated
    if (menuFetchInitiated) return;

    const token = sessionStorage.getItem("token");
    

    if (token) {
      dispatch(clearMenu());

      dispatch(listSideMenuPermission());
      setMenuFetchInitiated(true);
    } else {
      nav("/home");
    }
  }, [dispatch, nav, menuFetchInitiated]);

  if (!isAuthenticated()) {
    return <Navigate to={"/home"} replace />;
  }


  if (locationName === "/home") {
    return <>{element ?? <Outlet />}</>;
  }

 
  const flattenMenu = (arr: any[]): any[] => {
    return arr.flatMap((item) =>
      item.items ? [item, ...flattenMenu(item.items)] : [item]
    );
  };


  const hasViewPermission = (locationName: string) => {
    if (!menu) return undefined;

    const allMenuItems = Object.values(menu).flatMap((group: any) =>
      flattenMenu(group)
    );


    const normalizedPath = locationName
      .replace(/^\/+/, "") // remove leading slashes
      .replace(/\/+$/, ""); // remove trailing slashes

    const matched = allMenuItems.find((item: any) => {
      if (!item?.to) return false;
      const itemPath = item.to.replace(/^\/+/, "").replace(/\/+$/, "");
      return (
        normalizedPath === itemPath ||
        normalizedPath.startsWith(`${itemPath}/`)
      );
    });

    return matched?.permissions;
  };


  if (isLoading || !menuFetchInitiated || !menu || Object.keys(menu).length === 0) {
    return <Loading isLoading={true} />;
  }

  // 🛡 Check permission
  const permissions = locationName ? hasViewPermission(locationName) : undefined;

  if (permissions?.view) {
    dispatch(permissionsToPage(permissions));
    return <>{element ?? <Outlet />}</>;
  } else {
    return <Navigate to={"/home"} replace />;
  }
};

export default PrivateRoute;